import {Record} from 'immutable';
import uuid from 'uuid';
import {DEFAULT_COLOR_ID} from '~/constants/ProductConstants';

export default class NameAndNumber extends Record({
  id: null,
  name: '',
  number: '',
  productSize: '',
  productId: DEFAULT_COLOR_ID
}) {
  constructor({...initialValues}) {
    // size is a protected attribute on an Immutable Record object.
    // Our external services use size on personalization so we use
    // productSize internally and translate the property in the
    // serializer. Here we allow the constructor to accept that property
    initialValues.productSize = initialValues.size || initialValues.productSize;
    initialValues.name = initialValues.name || '';
    initialValues.number = initialValues.number || '';
    initialValues.id = initialValues.id || uuid.v4();
    super(initialValues);
  }
}
